import type { JSX } from 'react';

import { Glyph, type IconProps } from './Glyph';

/** The five slot states, each with a shape of its own — never colour alone. */

export function CheckIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="m4.5 12.5 5 5 10-11" />
    </Glyph>
  );
}

export function ClockIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3 2" />
      </g>
    </Glyph>
  );
}

export function SeatsIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="9" cy="8.5" r="3.25" />
        <path d="M3.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5" />
        <path d="M16 6.2a3.25 3.25 0 0 1 0 6" />
        <path d="M17.5 14.9c1.9.6 3 2.4 3 4.6" />
      </g>
    </Glyph>
  );
}

export function FullIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="12" cy="12" r="8.5" />
        <path d="m6.5 6.5 11 11" />
      </g>
    </Glyph>
  );
}

export function WaitlistIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M7 3.5h10M7 20.5h10" />
        <path d="M8 3.5c0 4 4 5.2 4 8.5 0 3.3-4 4.5-4 8.5" />
        <path d="M16 3.5c0 4-4 5.2-4 8.5 0 3.3 4 4.5 4 8.5" />
      </g>
    </Glyph>
  );
}

export function AlertIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M12 4.5 21 19.5H3z" />
        <path d="M12 10v4M12 17h.01" />
      </g>
    </Glyph>
  );
}
